import { SVGProps } from "react"

const PauseOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8139 3.125H12.8468C12.4827 3.125 12.1875 3.38665 12.1875 3.70942V15.3977C12.1875 15.7205 12.4827 15.9821 12.8468 15.9821H15.8139C16.178 15.9821 16.4732 15.7205 16.4732 15.3977V3.70942C16.4732 3.38665 16.178 3.125 15.8139 3.125Z"
        stroke={"currentColor"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.24161 3.125H4.27457C3.91043 3.125 3.61523 3.38665 3.61523 3.70942V15.3977C3.61523 15.7205 3.91043 15.9821 4.27457 15.9821H7.24161C7.60575 15.9821 7.90095 15.7205 7.90095 15.3977V3.70942C7.90095 3.38665 7.60575 3.125 7.24161 3.125Z"
        stroke={"currentColor"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export default PauseOutlineIcon
